import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "ph-custom-hb"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Custom Hinge and Bore Locations"),
  /*#__PURE__*/_createElementVNode("p", null, "Add custom hinge and bore locations or use Woodport's standards.")
], -1)
const _hoisted_3 = { class: "ph-hb-container" }
const _hoisted_4 = { class: "ph-hb-section ph-custom-hinge" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Standard Hinge Locations"),
  /*#__PURE__*/_createElementVNode("p", null, "Measured from the top of the door.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span", null, "80\""),
  /*#__PURE__*/_createElementVNode("span", null, "84\""),
  /*#__PURE__*/_createElementVNode("span", null, "90\""),
  /*#__PURE__*/_createElementVNode("span", null, "96\"")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "ph-hb-input ph-hb-checkbox"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "useStandardHinge" }, "Use Standard Hinge Locations", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hinge #1"),
  /*#__PURE__*/_createElementVNode("span", null, "7\""),
  /*#__PURE__*/_createElementVNode("span", null, "7\""),
  /*#__PURE__*/_createElementVNode("span", null, "7\""),
  /*#__PURE__*/_createElementVNode("span", null, "7\"")
], -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "hingeOne" }, "Hinge #1", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hinge #2"),
  /*#__PURE__*/_createElementVNode("span", null, "36-1/2\""),
  /*#__PURE__*/_createElementVNode("span", null, "38-1/2\""),
  /*#__PURE__*/_createElementVNode("span", null, "30\""),
  /*#__PURE__*/_createElementVNode("span", null, "32\"")
], -1)
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "hingeTwo" }, "Hinge #2", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hinge #3"),
  /*#__PURE__*/_createElementVNode("span", null, "66\""),
  /*#__PURE__*/_createElementVNode("span", null, "70\""),
  /*#__PURE__*/_createElementVNode("span", null, "53\""),
  /*#__PURE__*/_createElementVNode("span", null, "57\"")
], -1)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "hingeThree" }, "Hinge #3", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hinge #4"),
  /*#__PURE__*/_createElementVNode("span", null, "N/A"),
  /*#__PURE__*/_createElementVNode("span", null, "N/A"),
  /*#__PURE__*/_createElementVNode("span", null, "76\""),
  /*#__PURE__*/_createElementVNode("span", null, "82\"")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "ph-hb-input form-floating"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "hingeFour" }, "Hinge #4", -1)
const _hoisted_22 = { class: "ph-hb-section ph-custom-bore" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Standard Bore Locations"),
  /*#__PURE__*/_createElementVNode("p", null, "Measured from the top of the door.")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span", null, "80\""),
  /*#__PURE__*/_createElementVNode("span", null, "84\""),
  /*#__PURE__*/_createElementVNode("span", null, "90\""),
  /*#__PURE__*/_createElementVNode("span", null, "96\"")
], -1)
const _hoisted_25 = {
  key: 0,
  class: "ph-hb-input ph-hb-checkbox"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "useStandardBore" }, "Use Standard Bore Locations", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Deadbolt Bore"),
  /*#__PURE__*/_createElementVNode("span", null, "38-1/2\""),
  /*#__PURE__*/_createElementVNode("span", null, "42-1/2\""),
  /*#__PURE__*/_createElementVNode("span", null, "48-1/2\""),
  /*#__PURE__*/_createElementVNode("span", null, "54-1/2\"")
], -1)
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "boreOne" }, "Bore #1", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "ph-hb-standards" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Lock Bore"),
  /*#__PURE__*/_createElementVNode("span", null, "44\""),
  /*#__PURE__*/_createElementVNode("span", null, "48\""),
  /*#__PURE__*/_createElementVNode("span", null, "54\""),
  /*#__PURE__*/_createElementVNode("span", null, "60\"")
], -1)
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "boreTwo" }, "Bore #2", -1)
const _hoisted_33 = { class: "ph-hb-image" }
const _hoisted_34 = ["src"]

import { ref, onMounted, watch, PropType } from 'vue'
    import { useAppStore } from '@/stores/app'
    import { HingeBoreLocations } from '@/types/preHang'
    import { CustomHingeBoreLocations } from '@/services/prehang-classes/ph-hinge-bore'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomHingeBoreLocations',
  props: {
        doorHeight: { type: Number, required: false },
        hingeBore: { type: CustomHingeBoreLocations, required: true },
        boreSelection: { type: String, required: true, default: 'Single' },
        missingErrors: { type: Array as PropType<String[]>, required: true }
    },
  emits: ['updateCustomHb'],
  setup(__props, { emit: emits }) {

const props = __props

    const appStore = useAppStore()
    
    

    const useHingeStandards = ref<boolean>(false)
    const useBoreStandards = ref<boolean>(false)
    const standardIndex = ref<number>(-1)
    const locations = ref<HingeBoreLocations>({
        hingeOne: '',
        hingeTwo: '',
        hingeThree: '',
        hingeFour: '',
        boreOne: '',
        boreTwo: ''
    })
    const nonStandardLocations = ref<HingeBoreLocations>({
        hingeOne: '',
        hingeTwo: '',
        hingeThree: '',
        hingeFour: '',
        boreOne: '',
        boreTwo: ''
    })

    const showSecondBore = function() {
        let bore = props.boreSelection.toLowerCase()
        return !(bore == 'single' || bore == 'none')
    }
    const showBore = function() {
        let bore = props.boreSelection.toLowerCase()
        return bore != 'none'
    }

    const standardHeights = [80,84,90,96]

    const hingeStandards = [
        ['7','36-1/2','66',''], //80
        ['7','38-1/2','70',''], //84
        ['7','30','53','76'],   //90
        ['7','32','57','82']    //96
    ]
    const boreStandards = [
        ['38-1/2','44'], // 80
        ['42-1/2','48'], // 84
        ['48-1/2','54'], // 90
        ['54-1/2','60']  // 96
    ]

    watch(useBoreStandards, () => {
        if(useBoreStandards.value && standardIndex.value >= 0) {
            nonStandardLocations.value.boreOne = locations.value.boreOne
            nonStandardLocations.value.boreTwo = locations.value.boreTwo
            locations.value.boreOne = boreStandards[standardIndex.value][0]
            locations.value.boreTwo = boreStandards[standardIndex.value][1]
        } else {
            locations.value.boreOne = nonStandardLocations.value.boreOne
            locations.value.boreTwo = nonStandardLocations.value.boreTwo 
        }
    })
    watch(useHingeStandards, () => {
        if(useHingeStandards.value && standardIndex.value >= 0) {
            nonStandardLocations.value.hingeOne = locations.value.hingeOne
            locations.value.hingeOne = hingeStandards[standardIndex.value][0]
            nonStandardLocations.value.hingeTwo = locations.value.hingeTwo
            locations.value.hingeTwo = hingeStandards[standardIndex.value][1]
            nonStandardLocations.value.hingeThree = locations.value.hingeThree
            locations.value.hingeThree = hingeStandards[standardIndex.value][2]
            nonStandardLocations.value.hingeFour = locations.value.hingeFour
            locations.value.hingeFour = hingeStandards[standardIndex.value][3]
        } else {
            locations.value.hingeOne = nonStandardLocations.value.hingeOne
            locations.value.hingeTwo = nonStandardLocations.value.hingeTwo
            locations.value.hingeThree = nonStandardLocations.value.hingeThree
            locations.value.hingeFour = nonStandardLocations.value.hingeFour
        }
    })

    watch(locations, () => {
        props.hingeBore.updateLocations(locations.value)
        emits('updateCustomHb')
    },{deep: true})

    onMounted(() => {
        if(props.hingeBore.locations) {
            locations.value = props.hingeBore.locations as any
        }
        if(props.doorHeight) {
            const index = standardHeights.indexOf(props.doorHeight)
            if(index >= 0) {
                standardIndex.value = index
            }
        }
    })

return (_ctx: any,_cache: any) => {
  return (!(!showBore() && props.hingeBore.noHingePrep))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_6,
                (standardIndex.value >= 0 && !props.hingeBore.noHingePrep)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "useStandardHinge",
                        class: "form-check-input",
                        "aria-label": "Use Standard Hinge Locations",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((useHingeStandards).value = $event))
                      }, null, 512), [
                        [_vModelCheckbox, useHingeStandards.value]
                      ]),
                      _hoisted_8
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _hoisted_9,
                (!props.hingeBore.noHingePrep)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["ph-hb-input form-floating", {'ph-error': props.missingErrors.includes('hingeOne')}])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((locations.value.hingeOne) = $event)),
                        type: "text",
                        class: "form-control",
                        id: "hingeOne",
                        placeholder: "Hinge #1",
                        disabled: useHingeStandards.value
                      }, null, 8, _hoisted_10), [
                        [_vModelText, locations.value.hingeOne]
                      ]),
                      _hoisted_11
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _hoisted_12,
                (!props.hingeBore.noHingePrep)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["ph-hb-input form-floating", {'ph-error': props.missingErrors.includes('hingeTwo')}])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((locations.value.hingeTwo) = $event)),
                        type: "text",
                        class: "form-control",
                        id: "hingeTwo",
                        placeholder: "Hinge #2",
                        disabled: useHingeStandards.value
                      }, null, 8, _hoisted_13), [
                        [_vModelText, locations.value.hingeTwo]
                      ]),
                      _hoisted_14
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _hoisted_15,
                (!props.hingeBore.noHingePrep)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["ph-hb-input form-floating", {'ph-error': props.missingErrors.includes('hingeThree')}])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((locations.value.hingeThree) = $event)),
                        type: "text",
                        class: "form-control",
                        id: "hingeThree",
                        placeholder: "Hinge #3",
                        disabled: useHingeStandards.value
                      }, null, 8, _hoisted_16), [
                        [_vModelText, locations.value.hingeThree]
                      ]),
                      _hoisted_17
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _hoisted_18,
                (!props.hingeBore.noHingePrep)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((locations.value.hingeFour) = $event)),
                        type: "text",
                        class: "form-control",
                        id: "hingeFour",
                        placeholder: "Hinge #4",
                        disabled: useHingeStandards.value
                      }, null, 8, _hoisted_20), [
                        [_vModelText, locations.value.hingeFour]
                      ]),
                      _hoisted_21
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_24,
                (standardIndex.value >= 0 && showBore())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "useStandardBore",
                        class: "form-check-input",
                        "aria-label": "Use Standard Bore Locations",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((useBoreStandards).value = $event))
                      }, null, 512), [
                        [_vModelCheckbox, useBoreStandards.value]
                      ]),
                      _hoisted_26
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _hoisted_27,
                (showSecondBore())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["ph-hb-input form-floating", {'ph-error': props.missingErrors.includes('boreOne')}])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((locations.value.boreOne) = $event)),
                        type: "text",
                        class: "form-control",
                        id: "boreOne",
                        placeholder: "Bore #1",
                        disabled: useBoreStandards.value
                      }, null, 8, _hoisted_28), [
                        [_vModelText, locations.value.boreOne]
                      ]),
                      _hoisted_29
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _hoisted_30,
                (showBore())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["ph-hb-input form-floating", {'ph-error': props.missingErrors.includes('boreTwo')}])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((locations.value.boreTwo) = $event)),
                        type: "text",
                        class: "form-control",
                        id: "boreTwo",
                        placeholder: "Bore #2",
                        disabled: useBoreStandards.value
                      }, null, 8, _hoisted_31), [
                        [_vModelText, locations.value.boreTwo]
                      ]),
                      _hoisted_32
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("img", {
              src: _unref(appStore).publicPath + '/door-custom-locations.png',
              alt: "Custom Hinge and Bore Locations"
            }, null, 8, _hoisted_34)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})